(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-learn-more"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '.collection-learn-more__body';

    const setup = (root) => {
      const text = root.querySelector('.collection-learn-more__text');
      const toggle = root.querySelector('.collection-learn-more__toggle');
      if (!text || !toggle || toggle.dataset.bound === 'true') return;

      const CLAMPED = 'collection-learn-more__text--clamped';

      // Measure against the unclamped element: if it already fits, there is nothing to
      // expand and the button stays hidden.
      const overflows = () => {
        text.classList.remove(CLAMPED);
        const full = text.scrollHeight;
        text.classList.add(CLAMPED);
        return text.clientHeight + 1 < full;
      };

      if (!overflows()) {
        text.classList.remove(CLAMPED);
        toggle.hidden = true;
        return;
      }

      toggle.hidden = false;
      toggle.dataset.bound = 'true';

      toggle.addEventListener('click', () => {
        const open = text.classList.toggle(CLAMPED) === false;
        toggle.setAttribute('aria-expanded', String(open));
        toggle.textContent = open ? toggle.dataset.labelLess : toggle.dataset.labelMore;
      });
    };

    const init = () => document.querySelectorAll(SELECTOR).forEach(setup);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Theme editor re-renders sections without a full page load.
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
